import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonDatetime, IonDatetimeButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonModal, IonNavLink, IonPage, IonRoute, IonRow, IonSpinner, IonTitle, IonToolbar, useIonAlert, useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AppHeader from "../../components/AppHeader/AppHeader";
import { useGenerateAccountStatementMutation } from "../../services/api/ebioro/ebioro";
import { useAppSelector } from "../../services/redux/hook";
import { Asset, DocumentTransactionParameters } from "../../types/types";
import "./GeneratePdfRequest.css";
import * as Sentry from '@sentry/react';

const GeneratePdfRequest: React.FC = () => {

    const nav = document.querySelector("ion-nav");

    const selectedAsset: Asset = useAppSelector((state) => state.selectedAsset);
    const { t, i18n } = useTranslation();
    const [startDate, setstartDate] = useState("");
    const [endDate, setendDate] = useState("");
    const [isSpinner, setIsSpinner] = useState(false);
    const [present] = useIonAlert();

    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const [generateAccountStatement] = useGenerateAccountStatementMutation();

    const startDateChange = (event: any) => {
        let formatStartDate = moment.utc(event).format('YYYY-MM-DD')
        setstartDate(formatStartDate)

    }
    const endDateChange = (event: any) => {
        let formatEndDate = moment.utc(event).format('YYYY-MM-DD')
        setendDate(formatEndDate)

    }

    const generatePdf = async () => {

        setIsSpinner(true);

        const params: DocumentTransactionParameters = {
            asset_code: selectedAsset.code,
            start_date: startDate,
            end_date: endDate
        }

        try {

            await generateAccountStatement(params).unwrap();

            await new Promise(r => setTimeout(r, 2000)); // just wait 2 seconds to make the transition to the pdf main page smother

            goToPdfPage();

        } catch (error) {

            Sentry.captureException(error)
            presentErrorAlert({ data: t('application.uncaught.ERROR') });
            return

        }finally{
            setIsSpinner(false);
        }


    }

    const goToPdfPage = () => {

        nav?.pop();

    }

    return (

        <IonPage>

            <IonHeader className="ion-no-border">
                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonNavLink routerDirection={'back'}>
                        <IonButtons slot='start'>
                            <IonButton color={'primary'}>
                                <IonIcon slot='start' icon={arrowBackOutline} />
                            </IonButton>
                        </IonButtons>
                    </IonNavLink>
                    <IonTitle > {`${selectedAsset.code}`} </IonTitle>

                </IonToolbar>
                

            </IonHeader>

            <IonContent>
                <IonCard className="ion-padding">

                    <IonGrid className="ion-padding">

                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel> {t('GeneratePdf.Page.STARTDATE_LABEL') as string}</IonLabel>

                            </IonCol>
                            <IonCol size='6'>
                                <IonLabel> {t('GeneratePdf.Page.ENDDATE_LABEL')}</IonLabel>

                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-text-start">
                                <IonDatetimeButton datetime="startDatetime" />
                                <IonModal keepContentsMounted={true}>
                                    <IonDatetime
                                        className="generatePdfDateTime"
                                        id="startDatetime"
                                        presentation="date"
                                        onIonChange={(e: any) => startDateChange(e.detail.value)}
                                    />

                                </IonModal>

                            </IonCol>

                            <IonCol className="ion-text-start">
                                <IonDatetimeButton datetime="endDatetime" />
                                <IonModal keepContentsMounted={true}>
                                    <IonDatetime
                                        className="generatePdfDateTime"
                                        id="endDatetime"
                                        presentation="date"
                                        onIonChange={(e: any) => endDateChange(e.detail.value)}
                                    >

                                    </IonDatetime>
                                </IonModal>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                </IonCard>

            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        color={'primary'}
                        type='submit'
                        disabled={startDate === "" || endDate === "" || moment.utc(startDate).isAfter(moment.utc(endDate))}
                        expand="block"
                        id='pageFooterButton'
                        onClick={() => generatePdf()}
                    >
                        {isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                            : t('GeneratePdf.Page.BUTTON_LABEL')}
                    </IonButton>
                </IonToolbar>
            </IonFooter>

        </IonPage>
    )
}

export default GeneratePdfRequest